function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M492 352c11.046 0 20-8.954 20-20V120c0-44.112-35.888-80-80-80h-26V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v20h-91V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v20h-90V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v20H80C35.888 40 0 75.888 0 120v312c0 44.112 35.888 80 80 80h352c44.112 0 80-35.888 80-80 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 22.056-17.944 40-40 40H80c-22.056 0-40-17.944-40-40V120c0-22.056 17.944-40 40-40h25v20c0 11.046 8.954 20 20 20s20-8.954 20-20V80h90v20c0 11.046 8.954 20 20 20s20-8.954 20-20V80h91v20c0 11.046 8.954 20 20 20s20-8.954 20-20V80h26c22.056 0 40 17.944 40 40v212c0 11.046 8.954 20 20 20z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 210,
  r: 20
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 299,
  cy: 210,
  r: 20
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 386,
  cy: 210,
  r: 20
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 297,
  r: 20
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 384,
  r: 20
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 210,
  r: 20
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 297,
  r: 20
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 384,
  r: 20
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 299,
  cy: 297,
  r: 20
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 386,
  cy: 297,
  r: 20
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 299,
  cy: 384,
  r: 20
});

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

export default SvgCalendar;